import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataService } from 'app/data.service';

@Component({
  selector: 'app-view-states',
  templateUrl: './view-states.component.html',
  styleUrls: ['./view-states.component.css']
})
export class ViewStatesComponent implements OnInit {
	provincesData:any[];
	provinceName:string;
	provinceId:number;
	provinceIndex:number;
	status: boolean;
	response: string;

  constructor(private dataService : DataService) { }

  provinceData: FormGroup = new FormGroup({
    province: new FormControl('', [Validators.required])
  })

  ngOnInit(): void {
  	this.dataService.states()
  		.subscribe((provinces:any) => {
  			this.provincesData = provinces.provinces;
  		})
  }

  formValue(province,index){
  	this.provinceName = province.province;
  	this.provinceId = province.id;
  	this.provinceIndex = index;
  }

  editProvinceData(value){
  	if(value['province'] != ""){
  		this.dataService.editState(value,this.provinceId)
      .subscribe( (response:any) => {
        if(response.status){
        	this.response = response.message;
        	this.status = response.status;
        	this.provincesData.splice(this.provinceIndex, 1, response.province);
        }
        else{
        	this.response = response.message;
        	this.status = response.status;
        }
      });
  	}
  	else{
  		this.response = "Please Change The Value";
  		this.status = false;
  	};
  }

  scroll(el:HTMLElement){
  	el.scrollIntoView();
  }
}
